/**
 * @generated SignedSource<<6290f11c1e81d2d82acf372c3527868a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type UtilizationGrantCreateInput = {
  permissions?: ReadonlyArray<UtilizationGrantPermission>;
  reservationId: string;
  to: UtilizationGrantTo;
};
export type UtilizationGrantTo = {
  organization?: OrgGrantInput | null | undefined;
  user?: UserGrantInput | null | undefined;
  userEmail?: UserEmailGrantInput | null | undefined;
};
export type UserGrantInput = {
  userId: string;
};
export type UserEmailGrantInput = {
  email: string;
};
export type OrgGrantInput = {
  organizationId: string;
};
export type ShareAccessAccountDrawerShareMutation$variables = {
  input: UtilizationGrantCreateInput;
};
export type ShareAccessAccountDrawerShareMutation$data = {
  readonly lockUtilizationGrantCreate: {
    readonly id: string;
    readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
  };
};
export type ShareAccessAccountDrawerShareMutation = {
  response: ShareAccessAccountDrawerShareMutation$data;
  variables: ShareAccessAccountDrawerShareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessAccountDrawerShareMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessAccountDrawerShareMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "030587679855af91bfac86f95e56df8e",
    "id": null,
    "metadata": {},
    "name": "ShareAccessAccountDrawerShareMutation",
    "operationKind": "mutation",
    "text": "mutation ShareAccessAccountDrawerShareMutation(\n  $input: UtilizationGrantCreateInput!\n) {\n  lockUtilizationGrantCreate(input: $input) {\n    id\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "a20d3e4f57a462312e39ab0e87457fef";

export default node;
